import { FC } from 'react';
import { IonSearchbar } from '@ionic/react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    searchContainer: {
        padding: '4px 0',
        marginBottom: 8
    },

    searchbar: {
        '--background': 'var(--ion-color-step-50)',
        '--border-radius': '20px',
        '--box-shadow': 'none',
        '--placeholder-color': 'var(--ion-color-medium)',
        '--icon-color': 'var(--ion-color-medium)',
        padding: 0,
        minHeight: 36,

        '& .searchbar-search-icon': {
            marginInlineStart: '8px !important'
        },

        '& .searchbar-input': {
            paddingInlineStart: '42px !important'
        }
    }
});

interface SearchBarProps {
    value: string;
    onValueChange: (value: string) => void;
    onClear?: () => void;
    placeholder?: string;
    'data-id'?: string;
}

export const SearchBar: FC<SearchBarProps> = ({ value, onValueChange, onClear, placeholder = 'Search...', 'data-id': dataId }) => {
    const classes = useStyles();

    return (
        <div className={classes.searchContainer}>
            <IonSearchbar
                className={classes.searchbar}
                placeholder={placeholder}
                value={value}
                onIonInput={(e) => onValueChange(e.detail.value || '')}
                onIonClear={() => onClear?.()}
                debounce={0}
                mode="ios"
                data-id={dataId}
            />
        </div>
    );
};
